<a *ngIf="user" href="#" [matMenuTriggerFor]="menuUser" onclick="return false">
  <img *ngIf="user.avatar !== 'https://api.wishes.inc/img/default-client-avatar.png'; else defaultAvatar"
    [src]="user.avatar" alt="" class="nav-menu__image">
  <ng-template #defaultAvatar>
    <img src="https://api.brn.ai/img/default-client-avatar.png" alt="" class="nav-menu__image">
  </ng-template>
</a>
<mat-menu #menuUser="matMenu" [class]="'brn-menu'">
  <a [href]="portalSettings.url + '/profile'" mat-menu-item class="user-menu__item">
    {{user?.name}}
    <br>
    <small>{{user?.email}}</small>
  </a>
  <a [href]="location.prepareExternalUrl('auth/logout')" class="user-menu__logout">
    <mat-icon>exit_to_app</mat-icon>
  </a>
</mat-menu>